import { DEFAULT_EVENT_IMAGE, getEventSportImage } from '@/shared/lib/event-images';

type ActivityCover = Readonly<{
  image: string;
  sportType?: { iconKey?: string; key?: string } | null;
}>;

/** Old serialized cards may still contain the unrelated running-photo fallback. */
export const getActivityCoverImage = ({ image, sportType }: ActivityCover): string => {
  const isFallback =
    !image || image === DEFAULT_EVENT_IMAGE || /(?:^|\/)event-lead(?:\.[\w-]+)?\.webp(?:\?.*)?$/u.test(image);

  return isFallback ? getEventSportImage(sportType?.iconKey || sportType?.key) : image;
};

/** API dates already include their year; older translated fixtures sometimes do not. */
export const getActivityDateLabel = (date?: string, year?: string): string => {
  if (!date) return '';
  return year && !/\b\d{4}\b/u.test(date) ? `${date} ${year}` : date;
};
